import { GET, POST, SUCCESS, FAILURE } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { BASE_URL } from "../utils/const/base-url";
import { sharedRedirectToLandingIfMissingBearerToken } from "../utils/shared-functions";

export async function verifyLogin(usuario, password) {
  try {
    let data = { error: true };
    const { status, body, message, idTypeWebUser } = await fetch(
      `${BASE_URL}/autenticacion/login-web`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: POST,
        body: JSON.stringify({ usuario, password }),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (status === SUCCESS) {
      data.error = false;
      data.token = body;
      data.idTypeWebUser = idTypeWebUser;
    }
    if (status === FAILURE) {
      data.error = true;
      data.message = message;
      data.token = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("verifyLogin err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function verificarToken() {
  try {
    let data = { error: true };
    let headers;
    try {
      headers = getHeaders();
    } catch (headerErr) {
      if (sharedRedirectToLandingIfMissingBearerToken(headerErr)) {
        return { error: true, message: headerErr.message };
      }
      throw headerErr;
    }
    const { status, body, message, } = await fetch(
      `${BASE_URL}/autenticacion/verificar-token-web`,
      {
        headers: headers,
        method: GET,
      }
    ).then((res) => res.json());
    // console.log('status');
    // console.log(status);
    // console.log('body');
    // console.log(body);
    if (status === SUCCESS) {
      data.error = false;
      data.token = body.token;
      data.idRol = body.idRol;
      data.idTipoUsuario = body.idTipoUsuario;
    }
    if (status === FAILURE) {
      data.error = true;
      data.message = message;
      data.token = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("verificarToken err");
    console.log(err);
    if (sharedRedirectToLandingIfMissingBearerToken(err)) {
      return { error: true, message: err.message };
    }
    return { error: true, message: err };
  }
}